import './LeftSidebarMenu.css'

import { type FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { signOut } from 'supertokens-auth-react/recipe/session'

import LogoutIcon from '@/assets/icons/logout-icon.svg?react'
import { LangSwitcher } from '@/components/LangSwitcher/LangSwitcher'
import { MenuIList } from '@/components/MenuIList'
import { RouterPath } from '@/models/enums'
import { headerSidebarLinks } from '@/router'
import { activityTrackingService } from '@/services/ActivityTrackingService'
import { useAppStore } from '@/store/app'

const LeftSidebarMenu: FC = () => {
  const isMenuOpen = useAppStore((state) => state.isMenuOpen)
  const { t } = useTranslation('menu')
  const navigate = useNavigate()

  const handlerLogout = async () => {
    await signOut()
    activityTrackingService.trackUserLogout()
    navigate(`/${RouterPath.Login}`)
  }

  return (
    <aside className={`menu ${isMenuOpen ? 'open' : ''}`}>
      <MenuIList routes={headerSidebarLinks(t)} />
      <div className="sidebar__divider" />
      <div className="flex justify-between">
        <button type="button" className="logout-button" onClick={handlerLogout}>
          {t('logout')} <LogoutIcon width={15} height={15} className="ml-2" />
        </button>
        <LangSwitcher />
      </div>
    </aside>
  )
}

export const LeftSidebarMenuMemo = memo(LeftSidebarMenu)
